import React, { useState, useEffect } from "react";
import ArborescenceBâtimentaireClasseur from "./ArborescenceCorrespondanceClasseur";
import { Actif, Classeur, Site } from "../../interfaces";
import {  classeursService, sitesSerivces,actifsService } from "../../services";
import { showToast } from "..";

import { useForm } from "react-hook-form";
import { ArborescenceBâtimentaireV3 } from "../actif_arborescence/ArborescenceBâtimentaire";
import { MultiSelect } from "primereact/multiselect";
import { useAuth } from "../../utils/UserProvider";
import { TabView, TabPanel } from 'primereact/tabview';
import { useQueryClient } from "@tanstack/react-query";

interface FormEditCorrespondanceClasseurProps {
  actif :Actif[];
  selectedClasseur: Classeur;
  closeModalEdit: () => void;
  setLoading: (newvalue: boolean) => void;
}
const FormEditCorrespondanceClasseur = ({
  actif,
  selectedClasseur,
  closeModalEdit,
  setLoading,
}: FormEditCorrespondanceClasseurProps) => {
  const [selectedSite, setSelectedSite] = useState<Site  | null>(null);
  const [selectedActif, setSelectedActif] = useState<Actif  | null>(null);
  const [sites, setSites] = useState<Site[]>([]);
  const { user,client } = useAuth();
  const [actifs, setActifs] = useState<Actif[]>(actif);
  
 


  const queryClient = useQueryClient();
  
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const [selectedactifs, setSelectedactifs] = useState(
    Array.from(new Set([
      ...selectedClasseur?.bâtiments?.map((batiment) => batiment.actif_id || []),
      ...selectedClasseur?.niveaux?.map((niveau) => niveau.actif_id || []),
      ...selectedClasseur?.espaces?.map((espace) => espace.actif_id || []),
      ...selectedClasseur?.pieces?.map((piece) => piece.actif_id || []),
    ]))
  );
  const [selectedactifss, setselectedactifss] = useState<Actif[]>([]);
  useEffect(() => {
  setselectedactifss(actifs.filter((actif) =>
  selectedactifs.includes(actif.id)));
  }, [selectedactifs]);


  const [id_actifs, setid_actifs] = useState([]);
  useEffect(() => {
    setid_actifs(selectedactifss?.map((actif) => actif.id));
  }, [selectedactifss]);
 
 
  const [selectedBâtiments, setSelectedBâtiments] = useState(
    selectedClasseur?.bâtiments.map((batiment) => batiment.id)
  );
  const [selectedNiveaux, setSelectedNiveaux] = useState(
    selectedClasseur?.niveaux.map((niveau) => niveau.id)
  );
  const [selectedEspaces, setSelectedEspaces] = useState(
    selectedClasseur?.espaces.map((espace) => espace.id)
  );
  const [selectedPieces, setSelectedPieces] = useState(
    selectedClasseur?.pieces.map((piece) => piece.id)
  );



 
  useEffect(() => {
    // Simulate data fetching
    const fetchSitesAPI = async () => {
      try {
        setLoading(true);
        const response = await sitesSerivces.getAll();
        setSites(response);
        setLoading(false);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    fetchSitesAPI();
    
  }, []);
 
  useEffect(() => {
    const FetchActifs = async (site_id) => {
      try {
        setLoading(true);
        if (site_id !== undefined) {
          const response = await actifsService.getActifsBySite(site_id);
          setActifs(response);
          
        }
        setLoading(false);
      } catch (e) {
        console.log("Error while fetching", e);
      }
    };
    if (selectSite) {
      FetchActifs(selectedSite?.id);
    }
  }, [selectedSite]);
 
  const selectSite = async (site_id) => {
    try {
      setLoading(true);
      const response = await sitesSerivces.getById(site_id);
      setSelectedSite(response);
      setLoading(false);
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };
 
  const selectActif = async (actif_id) => {
    try {
      setLoading(true);
      const response = await actifsService.getById(actif_id);
      setSelectedActif(response);
 
      setLoading(false);
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };
 
  const onSubmit = async (data) => {
    try {
      let data_correspondance = {};
      setLoading(true);
      if (id_actifs.length !=0) {
        data_correspondance = {
          classeur_id: selectedClasseur.id,
          actif_id: id_actifs,
          site_id:sites[0]?.id,
          batiment_ids: selectedBâtiments,
          niveau_ids: selectedNiveaux,
          espace_ids: selectedEspaces,
          piece_ids: selectedPieces,
        };
   
        await classeursService
          .correspondanceClasseur(data_correspondance)
          .then((response) => {
            setLoading(false);
            showToast(
              "success",
              "Correspondance bâtimentaire effectué avec succès"
            );
            queryClient.refetchQueries({
              queryKey: ["classeurs"],
            });
            closeModalEdit();
          });
      } else {
        
        data_correspondance = {
          classeur_id: selectedClasseur.id,
          batiment_ids: selectedBâtiments,
          niveau_ids: selectedNiveaux,
          espace_ids: selectedEspaces,
          piece_ids: selectedPieces,
        };

        await classeursService
          .correspondanceClasseur(data_correspondance)
          .then((response) => {
            setLoading(false);
            showToast(
              "success",
              "Correspondance bâtimentaire effectué avec succès"
            );
            queryClient.refetchQueries({
              queryKey: ["classeurs"],
            });
            closeModalEdit();
          });
      }
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };
 
  const itemTemplate = (option) => {

    return (
      <div>
        {
          <span>{`${option.nom_actif} `}</span>
         }
      </div>
    );
  };
 
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
       
          <>
            
            <form
              onSubmit={handleSubmit(onSubmit)}
              encType="multipart/form-data"
            >
              <div className="col-span-6 sm:col-span-6">
               
              <MultiSelect
                        itemTemplate={itemTemplate}
                        value={selectedactifss}
                        options={actifs}
                        onChange={(e) => {
                          if (e.value.length <= 3) {
                            setselectedactifss(e.value); // Allow selection if under the limit
                          }
                        }}
                        optionLabel="nom_actif"
                        placeholder="Sélectionner un ou plusieurs actifs"
                        className="h-12 my-3 border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
                        filter
                        showClear
                        display="chip"
                       
 
                      />
                 
              </div>


              
      <TabView >
        {selectedactifss && (
          selectedactifss.map((actif) => (
            <TabPanel  header={actif?.nom_actif} >
             <div className="w-full max-h-96 overflow-auto space-y-4 mx-10 my-2">
             <ArborescenceBâtimentaireClasseur
                      site_id={actif.site_id}
                      actif={actif}
                      checkbox={true}
                      batimentIds={selectedClasseur?.bâtiments.map(
                        (batiment) => batiment.id
                      )}
                      niveauIds={selectedClasseur?.niveaux.map(
                        (niveau) => niveau.id
                      )}
                      espaceIds={selectedClasseur?.espaces.map(
                        (espace) => espace.id
                      )}
                      pieceIds={selectedClasseur?.pieces.map((piece) => piece.id)}
                      setSelectedBâtiments={setSelectedBâtiments}
                      setSelectedNiveaux={setSelectedNiveaux}
                      setSelectedEspaces={setSelectedEspaces}
                      setSelectedPieces={setSelectedPieces}
                      selectedBâtiments={selectedBâtiments}
                      selectedNiveaux={selectedNiveaux}
                      selectedEspaces={selectedEspaces}
                      selectedPieces={selectedPieces}
                     
                    />
              </div>
              
             
            </TabPanel>
            
        
           
          ))
        ) }
</TabView>
             
 
           
            </form>
          </>
       
        <div className="flex justify-end space-x-2 mt-10">
          <button
            type="submit"
            className="text-white   bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
          >
            modifier
          </button>
          <button
            type="button"
            onClick={() => {
              closeModalEdit();
            }}
            className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-2  text-center "
          >
            Annuler
          </button>
        </div>
      </form>
    </>
  );
};
 
export default FormEditCorrespondanceClasseur;